import React, { useState, useEffect } from "react";
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import { toast } from "react-toastify";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import { getMaxNftSize } from "../../services/common-query";

let maxNftSize = {
  val: 0,
  mb: 0,
};
function UpdateImagePortrait(props) {
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  useEffect(() => {
    getMaxImgSize();
  }, []);

  const getMaxImgSize = async () => {
    maxNftSize = await getMaxNftSize();
  };

  const onChangeImage = async ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftSize.val) {
      toast.error(`Image must be smaller than ${maxNftSize.mb} MB`, {
        position: "bottom-left",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    } else {
      props.setimageFile(newFileList);
    }
  };

  return (
    <div>
      <ImgCrop rotate aspect={1 / 1}>
        <Upload
          customRequest={dummyRequest}
          listType="picture-card"
          fileList={props.imageFile}
          onChange={onChangeImage}
          onPreview={onPreview}
        >
          {props.imageFile.length < 1 && (
            <>
              {props.photoUrl ? (
                <img
                  style={{ height: "auto", width: "inherit" }}
                  src={props.photoUrl}
                />
              ) : (
                <AddOutlinedIcon />
              )}
            </>
          )}
        </Upload>
      </ImgCrop>
    </div>
  );
}

export default UpdateImagePortrait;
